exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-icon-plus[data-v-9f640ec6] {\n  background-color: #fbfdff;\n  border: 1px dashed #c0ccda;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n.avatar[data-v-9f640ec6] {\n  width: 148px;\n  height: 148px;\n  display: block;\n}\n.avatar-uploader-icon[data-v-9f640ec6] {\n  font-size: 28px;\n  color: #8c939d;\n  width: 148px;\n  height: 148px;\n  line-height: 148px;\n  text-align: center;\n}\n.video-box[data-v-9f640ec6]{\n  border:1px dashed #c0ccda;\n  border-radius: 6px;\n  background-color: #fbfdff;\n}\n", ""]);

// exports
